import { Component, OnInit } from '@angular/core';
import { JhiAlertService, JhiEventManager } from 'ng-jhipster';
import { isNullOrUndefined } from 'util';
import { Observable } from 'rxjs/Observable';

import { AlertUtils, scrollToTop } from '../../../shared';
import { Faculty, User } from '../../../models';
import { UserService, Principal } from '../../../services';
import { CREATE_USERS_AUTHORITIES_MAP, DEFAULT_LANGUAGE, USER_LIST_MODIFICATION } from '../../../shared/constants';
import { HumanAuthorities } from '../../../shared/enums';

@Component({
    selector: 'qms-user-create',
    templateUrl: './user-create.component.html'
})
export class UserCreateComponent implements OnInit {
    public user: User;
    public isSaving: Boolean;
    public selectedAuthority: string;

    private enabledAuthorities: string[];
    private enabledFaculties: Observable<Faculty[]>;

    constructor(private userService: UserService,
                private eventManager: JhiEventManager,
                private alertService: JhiAlertService,
                private principal: Principal) {
        this.user = new User();
        this.user.authorities = [];
        this.user.langKey = DEFAULT_LANGUAGE;
        this.user.faculties = [];
        this.isSaving = false;
    }

    ngOnInit() {
        this.loadAuthorities();
        this.enabledFaculties = this.principal.userFaculties();
    }

    private loadAuthorities() {
        this.enabledAuthorities = [];
        Object.keys(HumanAuthorities).filter((authority: string) => {
            this.principal.hasAuthority(authority).then((resolved: boolean) => {
                if (resolved === true && !isNullOrUndefined(CREATE_USERS_AUTHORITIES_MAP[authority])) {
                    CREATE_USERS_AUTHORITIES_MAP[authority].forEach((enabledAuthority) => {
                        if (this.enabledAuthorities.some((value) => value === enabledAuthority) === false) {
                            this.enabledAuthorities.push(enabledAuthority);
                        }
                    });
                }
            });
        });
    }

    public save() {
        this.isSaving = true;
        this.user.authorities = [];
        if (this.selectedAuthority === 'ROLE_USER' || this.selectedAuthority === 'ROLE_SUPER_ADMIN') {
            this.user.faculties = [];
        }
        Object.keys(HumanAuthorities).forEach((authority) => {
            if (HumanAuthorities[authority] >= HumanAuthorities[this.selectedAuthority]) {
                this.user.authorities.push(authority);
            }
        });
        this.userService.create(this.user).subscribe((response: User) => {
            this.onSaveSuccess(response);
        }, () => {
            this.isSaving = false;
            scrollToTop();
        });
    }

    public cancel() {
        window.history.back();
    }

    private onSaveSuccess(result: User) {
        AlertUtils.notifySuccess(this.eventManager, this.alertService,
            'user.created', { param: result.login });

        this.eventManager.broadcast({ name: USER_LIST_MODIFICATION, content: 'OK' });
        this.isSaving = false;
        this.cancel();
    }

    public onFacultySelection(facultyId: number) {
        const id = this.user.faculties.indexOf(facultyId);
        if (id > -1) {
            this.user.faculties.splice(id, 1);
        } else {
            this.user.faculties.push(facultyId);
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/management/users/user-create.component.ts